<p-toolbar class="custom-header">
    <div class="p-toolbar-group-start hidden sm:block" style="flex-basis: 35%; ">
        <custom-input-simple
            [value]="searching"
            (parentFunction)="search($event)"
            [placeholder]="searchLabel"
            (valueChange)="onSearchChange($event)"
        ></custom-input-simple>
    </div>
    <div class="p-toolbar-group-center" routerLink="/">
        <img [src]="logoImage" height="85" class="cursor-pointer"/>
    </div>
    <div class="p-toolbar-group-end" style="flex-basis: 35%; justify-content: flex-end;">
      <ng-template #login>
        <div class="hidden  sm:block">
          <custom-button
            (click)="goToLogin()"
            label="Acceder"
            icon="pi pi-user"
            [text]="true"
          ></custom-button>
        </div>
      </ng-template>
      <div class="sm:hidden">
        <p-button *ngIf="!isLoggedUser"
          styleClass="p-button-lg p-button-rounded p-button-info p-button-text"
          (click)="goToLogin()"
          [pTooltip]="'Ingresar'"
          tooltipPosition="top"
          [text]="true">
          <i class="pi pi-sign-in"
            style="color: var(--primary-color);"
            [ngStyle]="{fontSize: '1.5rem'}"
          >
          </i>
        </p-button>
      </div>

      <p-button
        styleClass="p-button-lg p-button-rounded p-button-info p-button-text text-primary-color"
        [routerLink]="['/shopping-car']"
        [pTooltip]="'ir al Carrito'"
        tooltipPosition="top"
        [text]="true"
        >
        <i *ngIf="cantShoppingCartItems > 0" class="pi pi-shopping-cart text-xl" pBadge [value]="cantShoppingCartItems" severity="danger"></i>
        <i *ngIf="cantShoppingCartItems === 0" class="pi pi-shopping-cart text-xl"></i>
      </p-button>
      <p-button *ngIf="isLoggedUser"
        styleClass="p-button-lg p-button-rounded p-button-info p-button-text"
        (click)="logOut()"
        [pTooltip]="'Salir'"
        tooltipPosition="top"
        [text]="true">
        <i class="pi pi-sign-out"
          style="color: var(--primary-color);"
          [ngStyle]="{fontSize: '1.25rem'}"
        >
        </i>
      </p-button>
        <div class="hidden flex flex-column" *ngIf="isLoggedUser; else login ">
        <i class="pi pi-user"
          [pTooltip]="'Bienvenido ' + user.name + ' ' + user.lastName "
          tooltipPosition="top"
          style="color: var(--primary-color);"
          [ngStyle]="{fontSize: '1.25rem'}"

        >
        </i>
      </div>
    </div>
</p-toolbar>

<div class="customMenuPopup flex  justify-content-between ">
  <div class="p-toolbar-group-start  sm:hidden">
    <custom-input-simple
      [value]="searching"
      (parentFunction)="search($event)"
      [placeholder]="searchLabel"
      (valueChange)="onSearchChange($event)"
    ></custom-input-simple>
  </div>
  <p-menu #menu [model]="optionsPop" [popup]="true"></p-menu>
  <button class="sm:hidden text-white" [text]="true" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars"  ></button>
</div>

<p-tabMenu
    [model]="options"
    [activeItem]="activeOption"
    (activeItemChange)="onActiveItemChange($event)"
></p-tabMenu>
